module.exports = __webpack_public_path__ + "img/user.97bd5e19.png";